import { elementScrollIntoView } from "seamless-scroll-polyfill";

class GlossaryBlock {
    constructor(elem) {
        this.elem = elem;
        this.title = this.elem.querySelector(".js-glossary-block-title");
        this.links = this.elem.querySelectorAll(".js-glossary-block-link");
        this.items = this.elem.querySelectorAll(".js-glossary-block-item");

        if (this.links || this.items) {
            this._init();
        }
    }

    _init() {
        this._checkActiveLinkOnLoad();
        this._initTitleListener();
        this._initLinksListeners();
    }

    _checkActiveLinkOnLoad() {
        this.links.forEach((link) => {
            const linkIsActive = link.classList.contains("active");
            const linkDataId = link.dataset.id;

            if (linkIsActive && linkDataId) {
                const itemWithNecessaryId = document.getElementById(linkDataId);

                if (itemWithNecessaryId) {
                    this.elem.classList.add("active");

                    link.classList.add("active");

                    itemWithNecessaryId.classList.add("active");

                    elementScrollIntoView(itemWithNecessaryId, {
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }
        });
    }

    _initTitleListener() {
        if (!this.title) return;

        this.title.addEventListener("click", () => {
            if (this.elem.classList.contains("active")) {
                this.elem.classList.remove("active");

                this.links.forEach((link) => {
                    link.classList.remove("active");
                });

                this.items.forEach((item) => {
                    item.classList.remove("active");
                });
            } else {
                this.elem.classList.add("active");

                this.items.forEach((item) => {
                    item.classList.add("active");
                });
            }
        });
    }

    _initLinksListeners() {
        this.links.forEach((link) => {
            link.addEventListener("click", (e) => {
                e.preventDefault();

                const linkDataId = link.dataset.id;

                if (linkDataId) {
                    const itemWithNecessaryId = document.getElementById(linkDataId);

                    if (itemWithNecessaryId) {
                        if (!this.elem.classList.contains("active")) {
                            this.elem.classList.add("active");
                        }

                        this.links.forEach((link) => {
                            link.classList.remove("active");
                        });

                        link.classList.add("active");

                        this.items.forEach((item) => {
                            item.classList.remove("active");
                        });

                        itemWithNecessaryId.classList.add("active");

                        elementScrollIntoView(itemWithNecessaryId, {
                            behavior: "smooth",
                            block: "center",
                        });
                    }
                }
            });
        });
    }
}

window.addEventListener("load", () => {
    const glossaryBlocks = document.querySelectorAll(".js-glossary-block");

    if (glossaryBlocks) {
        for (const item of glossaryBlocks) {
            new GlossaryBlock(item);
        }
    }
});
